import { X, Moon, Sun, Monitor } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useGameAppearance } from '@/contexts/GameAppearanceContext'

interface GameSettingsModalProps {
  isOpen: boolean
  onClose: () => void
}

// Só a seção de Aparência ficou: as antigas Sons/Notificações/Layout gravavam
// `gameSettings` no localStorage que nenhum outro código lia (placebo) e foram
// removidas. Se forem implementadas de verdade, reintroduzir aqui.
export function GameSettingsModal({ isOpen, onClose }: GameSettingsModalProps) {
  const { appearance, setAppearance } = useGameAppearance()

  if (!isOpen) return null

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md bg-game-secondary dark:bg-zinc-900 rounded-2xl shadow-2xl z-50 overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-game-border-primary dark:border-zinc-800">
          <h2 className="text-lg font-semibold text-game-primary dark:text-zinc-100">
            Configurações do Jogo
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-game-hover dark:hover:bg-zinc-800 transition-colors"
          >
            <X className="h-5 w-5 text-game-muted" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6 max-h-[60vh] overflow-y-auto">
          {/* Tema */}
          <div className="space-y-3">
            <h3 className="text-sm font-medium text-game-secondary dark:text-zinc-300 flex items-center gap-2">
              <Moon className="h-4 w-4" /> Aparência
            </h3>
            <div className="grid grid-cols-3 gap-2">
              {[
                { value: 'light', icon: Sun, label: 'Claro' },
                { value: 'dark', icon: Moon, label: 'Escuro' },
                { value: 'system', icon: Monitor, label: 'Sistema' },
              ].map(({ value, icon: Icon, label }) => (
                <button
                  key={value}
                  onClick={() => setAppearance(value as 'light' | 'dark' | 'system')}
                  className={cn(
                    "flex flex-col items-center gap-1.5 p-3 rounded-xl border transition-all",
                    appearance === value
                      ? "border-violet-500 bg-violet-500/10 text-violet-600 dark:text-violet-400"
                      : "border-game-border-primary dark:border-zinc-700 text-game-muted hover:border-violet-300 dark:hover:border-zinc-600"
                  )}
                >
                  <Icon className="h-5 w-5" />
                  <span className="text-xs font-medium">{label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-game-border-primary dark:border-zinc-800 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-white bg-violet-600 hover:bg-violet-700 rounded-lg transition-colors"
          >
            Fechar
          </button>
        </div>
      </div>
    </>
  )
}

export default GameSettingsModal
